objIsWrapped